'use client';

import React, { memo } from 'react';
import { usePathname } from 'next/navigation';
import { MasterData } from '~/types/master-data';

export const JobsLinksFooter = memo(function JobsLinksFooter({
  masterData,
}: {
  masterData: MasterData;
}) {
  const pathname = usePathname();
  const hiddenPath = [
    '/jobs',
    '/prefectures',
    '/categories',
    '/types',
    '/licenses',
    '/contracts',
    '/features',
    '/annual_salary_mins',
  ];
  const isHidden = hiddenPath.some((path) => pathname.startsWith(path));

  if (isHidden) {
    return <></>;
  }

  return (
    <div className="l-footer-menu">
      <div className="l-container">
        <div className="l-footer-links">
          <div className="l-footer-links__list">
            <div className="l-footer-links__title">資格から探す</div>
            <ul>
              {masterData.licenses?.map((license) => {
                if (license.license_id === null) {
                  return (
                    <li key={license.id}>
                      <a href={`/licenses/license_${license.id}`}>
                        {license.name}
                      </a>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
          <div className="l-footer-links__list">
            <div className="l-footer-links__title">職種から探す</div>
            <ul>
              {masterData.categories?.map((category) => (
                <li key={category.id}>
                  <a href={`/categories/category_${category.id}`}>
                    {category.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="l-footer-links__list">
            <div className="l-footer-links__title">工事の種類から探す</div>
            <ul>
              {masterData.types?.map((type) => (
                <li key={type.id}>
                  <a href={`/types/type_${type.id}`}>{type.name}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="l-footer-links__list">
            <div className="l-footer-links__title">勤務地から探す</div>
            {masterData.areas?.map((area) => {
              if (area.name === '関東' || area.name === '近畿') {
                return (
                  <ul key={area.id}>
                    {area.name}：
                    {masterData.prefectures?.map((prefecture) => {
                      if (prefecture.area_id === area.id) {
                        return (
                          <li key={prefecture.id}>
                            <a
                              href={`/prefectures/prefecture_${prefecture.id}`}
                            >
                              {prefecture.name}
                            </a>
                          </li>
                        );
                      }
                    })}
                  </ul>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
});
